
import RouterService from '@/service/RouterService'
import { Component, Vue } from 'vue-property-decorator'
import RacingService from '@/biz/service/Racing/RacingService'

@Component
export default class RacingChildrenIndex extends Vue {
  private Service = RacingService

  private get parentTitle () {
    return RouterService.query('title') || ''
  }

  private levelText (level: number) {
    const map: { [key: number]: string } = { 1: '周赛', 2: '月赛', 3: '年赛' }
    return map[Number(level)] || '普通'
  }

  private handleLoad (params: object) {
    return RacingService.index({ ...params, racing_id: RouterService.query('racing_id') } as any)
  }

  private handleEntra (v: { id: string }) {
    RouterService.push('/racing/info', { racing_id: v.id, id: v.id })
  }
}
